import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Session is delivered as an HttpOnly cookie set by /api/auth/verify.
// We include credentials on every request so the cookie rides along.
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const url = err?.config?.url || "";
      const path = window.location.pathname || "/";
      // /auth/me is our silent session probe on mount — a 401 there just means
      // "not signed in" and must not trigger a redirect.
      const isMeProbe = url.endsWith("/auth/me");
      // Public routes (home + sign-in + magic-link callback) legitimately
      // trigger 401s for signed-out visitors (e.g. the homepage's
      // AdvisorRolodex fetches /ideas to check for deep-link mode). Redirecting
      // "/" -> "/" would force a full reload on the same page, causing an
      // infinite reload loop. Only bounce to "/" from PROTECTED routes.
      const onPublicRoute =
        path === "/" || path === "/signin" || path.startsWith("/auth");
      if (!isMeProbe && !onPublicRoute) {
        window.location.href = "/";
      }
    }
    return Promise.reject(err);
  }
);
